jQuery( function() {
    const header = document.getElementById( 'main-header' );
    const topbar = header.querySelector( '.topbar' );
    const main = header.querySelector( '.navbar' );

    let scrolled = 0;
    let lastPosition = 0;

    setHeaderState();
    document.addEventListener( 'scroll', setHeaderState, { passive: true } )

    function setHeaderState() {
        const scrollDiff = window.scrollY - lastPosition;

        scrolled += scrollDiff;

        if ( scrolled > 100 ) {
            header.dataset['scrolled'] = true;
            scrolled = 0;
        } else if (scrolled < -100 || window.scrollY === 0) {
            header.dataset['scrolled'] = false;
            scrolled = 0;
        }

        lastPosition = window.scrollY;
    }
})